import { render, staticRenderFns } from "./current-conversation.vue?vue&type=template&id=0b473419&scoped=true"
import script from "./current-conversation.vue?vue&type=script&lang=js"
export * from "./current-conversation.vue?vue&type=script&lang=js"
import style0 from "./current-conversation.vue?vue&type=style&index=0&id=0b473419&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b473419",
  null
  
)

export default component.exports